/* @flow */

import React from "react";
import { useTranslate } from "@awardit/react-use-translate";
import styles from "./styles.scss";

const CartInfoText = (): React$Node => {
  const t = useTranslate();

  return (
    <div className={styles.customerServiceLink}>
      <div className={styles.text}>
        <p dangerouslySetInnerHTML={{ __html: t("CHECKOUT.DISCOUNT_TEXT.1") }} />
        <p dangerouslySetInnerHTML={{ __html: t("CHECKOUT.DISCOUNT_TEXT.2") }} />
        <span>{t("CHECKOUT.NEED_HELP")}</span>
        <br />
        <a href={t("CUSTOMER_SERVICE.LINK")} target="_blank" rel="noopener noreferrer">
          {t("CHECKOUT.CONTACT_CUSTOMER_SERVICE")}
        </a>
      </div>
    </div>
  );
};

export default CartInfoText;
